import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/swiper-bundle.css";

const testimonials = [
  {
    name: "Anita Saini",
    position: "Himachal Pradesh University, Shimla",
    quote:
      "Shankar IAS Academy offers a strong and structured education with highly relevant study materials, especially in History, Polity, and International Relations. Adding weekly debates, quizzes, and regular current affairs sessions would further enhance learning. Weekly tests for prelims and mains could also improve exam preparedness. Overall, the academy provides quality education and a valuable learning experience.",
  },
  {
    name: "Ritika",
    position: "Himachal Pradesh University, Shimla",
    quote:
      "I give Shankar IAS Academy a 5-star rating for its supportive environment and dedicated faculty. The teaching staff and management genuinely care about students, fostering a strong teacher-student connection. Despite resource challenges, the faculty remained enthusiastic, delivering top-notch content in interactive classes. The academy feels like a family, not just a coaching institute, truly invested in students' success. Thank you for the unwavering support!",
  },

  //  {
  //   name: "Aditya Katach",
  //   position: "Himachal Pradesh University, Shimla",
  //   quote:
  //     "Studying at Shankar IAS Academy was a great experience. The faculty's efforts ensured a clear understanding of every subject, making learning smooth and effective. I truly appreciate the quality education provided and am grateful to the academy for bringing it to HP.",
  // },


  {
    name: "Avinash Singh",
    position: "Himachal Pradesh University, Shimla",
    quote:
      "I sincerely appreciate Shankar IAS Academy's exceptional guidance and support. The expert faculty, well-structured courses, and high-quality study materials have greatly enhanced my UPSC preparation. Regular test series, doubt-clearing sessions, and Mains answer writing practice made learning effective and boosted my confidence. Thank you for your dedication to student success!",
  },
  {
    name: "Nikita Singh",
    position: "Himachal Pradesh University, Shimla",
    quote:
      "I sincerely appreciate the guidance and support from S.I.A. The teachers are supportive, and the study material is of good quality. However, some materials are pending, and I request their prompt delivery. Regular test series for the Preliminary exam would also help improve preparation and assessment.",
  },

 
];

const Testimonial = () => {
  return (

  <div className="testimonialSection">

  <div className="container">

    <h3 className="testimonialTitle text-center">
      Student Testimonials  <br/>
    </h3>

    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      spaceBetween={30}
      slidesPerView={3}
      loop
      navigation
      pagination={{ clickable: true }}
      autoplay={{ delay: 5000 }}
      breakpoints={{
        320: { slidesPerView: 1 },
        640: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      }}
      className="testimonialSwiper"
    >

      {testimonials.map((testimonial, index) => (

        <SwiperSlide key={index}>

          <div className="testimonialCard">

            <div className="quoteIcon">
              <i className="bi bi-quote"></i>
            </div>

            <p className="testimonialText">
              {testimonial.quote}
            </p>

            <div className="testimonialAuthor">
              <h5>{testimonial.name}</h5>
              <span>{testimonial.position}</span>
            </div>

          </div>

        </SwiperSlide>

      ))}

    </Swiper>

  </div>

  <style jsx global>{`

    .testimonialSection{
      // background:#f6f8fb;
      padding:70px 0;
      }

    .testimonialTitle{
      font-family:Switzer-Bold;
      font-size:28px;
      margin-bottom:40px;
      position:relative;
      }

    .testimonialTitle::after{
      content:"";
      width:60px;
      height:3px;
      background:#d83a56;
      display:block;
      margin:10px auto 0;
      }

    .testimonialCard{
        background:#fff;
        padding:30px;
        border-radius:12px;
        height:100%;
        min-height:320px;   /* equal card size */
        box-shadow:0 10px 25px rgba(0,0,0,0.08);
        transition:all .3s ease;
        display:flex;
        flex-direction:column;
        justify-content:space-between;
      }

    // .testimonialCard:hover{
    //   transform:translateY(-6px);
    //   box-shadow:0 15px 35px rgba(0,0,0,0.12);
    //   }

    .quoteIcon{
      font-size:28px;
      color:#0d6efd;
      margin-bottom:10px;
      }

    .testimonialText{
      font-size:15px;
      line-height:26px;
      color:#444;
      margin-bottom:20px;
      }

    .testimonialAuthor h5{
      font-size:16px;
      color:#c62828;
      margin:0;
      }

    .testimonialAuthor span{
      font-size:13px;
      color:#777;
      }

    .swiper-button-prev,
    .swiper-button-next{
      width:38px;
      height:38px;
      background:white;
      border-radius:50%;
      box-shadow:0 8px 20px rgba(0,0,0,0.15);
      color:#d83a56;
      }

    .swiper-button-prev::after,
    .swiper-button-next::after{
      font-size:14px;
      }

    .swiper-button-prev:hover,
    .swiper-button-next:hover{
      background:#d83a56;
      color:#fff;
      }


  `}</style>`

</div>


  );
};

export default Testimonial;
